import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import employees from 'modules/employees/store/collections/employees'
import { employeeManagedEmployees } from 'modules/employees/store/collections/employeesContractVersions'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { peopleLedByEmployee } from 'modules/teams/store/peopleLedByEmployee'

export const useManagedIds = (manageEveryone: boolean) => {
  const { employee } = useCurrentSession()
  const currentEmployee = employees.find({ id: employee?.id })

  if (manageEveryone) {
    return {
      managedEmployeeIds: employees.map((e) => e.id),
      excludedEmployeeIds: [],
    }
  }
  const currentEmployeeId = Number(currentEmployee?.attributes.id)

  const ledEmployeeIds = currentEmployee
    ? peopleLedByEmployee(teams, memberships, currentEmployeeId, contractVersions).map((e) => e.id)
    : []
  const managedEmployeeIds = currentEmployee
    ? employeeManagedEmployees(currentEmployee, contractVersions).map((e) => e.id)
    : []

  let result: number[] = []

  // If the employee leads and manages other employees, return only the intersection
  if (ledEmployeeIds.length > 0 && managedEmployeeIds.length > 0) {
    // We filter ledEmployeeIds to only keep those that are also in managedEmployeeIds
    // This ensures we only return employees who are both led and managed by the current employee
    result = ledEmployeeIds.filter((id) => managedEmployeeIds.includes(id))
  } else if (ledEmployeeIds.length > 0) {
    result = ledEmployeeIds
  } else {
    result = managedEmployeeIds
  }

  // Ensure the current employee is included in the result if not already present
  if (currentEmployeeId && !result.includes(currentEmployeeId)) {
    result.push(currentEmployeeId)
  }

  const excludedEmployeeIds = employees.models
    .filter((e) => !result.includes(e.attributes.id))
    .map((e) => e.attributes.id)

  return { excludedEmployeeIds, managedEmployeeIds: result }
}
